import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, catchError, switchMap } from 'rxjs/operators';
import { ApiToolsService } from '../services/api-tools.service';
import { ConfirmDialogService } from '../services/confirm-dialog.service';
import { SharedToolsService } from '../services/shared-tools.service';
import { ROUTES_PATHS } from '../const/routes';

@Injectable({
	providedIn: 'root'
})

export class SuperAdminHelper {
	constructor(
		private apiToolsService: ApiToolsService,
		private router: Router,
		private confirmDialogService: ConfirmDialogService,
		private sharedToolsService: SharedToolsService,
	) {
	}

	canAccessSuperAdmin(): Observable<boolean> {
		return this.apiToolsService.isSuperAdmin().pipe(
			switchMap((response: any) => {
				const isSuperAdmin = response?.isSuperAdmin || false;
				if (!isSuperAdmin) {
					this.sharedToolsService.getJSON('txtModals').subscribe((txtModalsJson: any) => {
						this.confirmDialogService.confirmThis('', txtModalsJson.data.modalForbiddenAction, 'alert', '', () => {
							this.router.navigate([ROUTES_PATHS.MON_COMPTE]);
						}, () => {
						});
					});
				}
				return of(isSuperAdmin);
			}),
			catchError((error) => {
				console.error('Error checking super admin status:', error);
				return of(false);
			})
		);
	}
}
